export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';

export const GET_NOTIFICATION_SETTINGS = 'GET_NOTIFICATION_SETTINGS';

export const UPDATE_NOTIFICATION_SETTINGS = 'UPDATE_NOTIFICATION_SETTINGS';

export const READ_NOTIFICATION = 'READ_NOTIFICATION';

export const UPDATE_WEB_PUSH_TOKEN = 'UPDATE_WEB_PUSH_TOKEN';
